import type { CSSProperties } from 'react';
import styles from './Logo.module.css';

export interface LogoProps {
  /** Draws the tubes on, then lights them. Off for the static header version. */
  animate?: boolean;
  /** Visible size of the wordmark. */
  size?: 'md' | 'lg';
  /** Accessible name (usually the translated app name). */
  label: string;
}

/**
 * The neon sign. Pure SVG text with a stroke "tube", so it stays sharp at any size and is
 * replaceable through the asset manifest key `ui.logo.neon`.
 */
export function Logo({ animate = false, size = 'md', label }: LogoProps) {
  return (
    <svg
      className={[styles['logo'], styles[size], animate ? styles['animate'] : ''].join(' ')}
      viewBox="0 0 520 190"
      role="img"
      aria-label={label}
      style={{ '--len': 1400 } as CSSProperties}
    >
      <g className={styles['sign']} aria-hidden="true">
        <text className={`${styles['tube']} ${styles['small']}`} x="260" y="52" textAnchor="middle">
          {'IL'}
        </text>
        <text className={`${styles['tube']} ${styles['big']}`} x="260" y="158" textAnchor="middle">
          {'COLPO'}
        </text>
        <path className={styles['rule']} d="M60 34h130M330 34h130" />
      </g>
    </svg>
  );
}
